module.exports = __webpack_public_path__ + "static/img/1.90555d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news26/1.jpg
// module id = qhwS
// module chunks = 1